import { history } from 'modules/navigator';
import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
// import ScoresRecharge from './scoresRecharge';
// import ScoresRecord from './scoresRecord';
import Vip from './vip';
import PubSale from './pubSale';

class Router extends BrowserRouter {
  public history = history;
}

export default function EswjApp({ match }) {
  return (
    <Router>
      <Route path={`${match.path}/vip`} component={Vip} />
      <Route path={`${match.path}/pubSale`} component={PubSale} />
    </Router>
  );
}
